// extracted by mini-css-extract-plugin
export var actionButton = "_gf-t";
export var buttonContainer = "_gf-0";
export var buttonContainer2 = "_gf-1";
export var buttonSection = "_gf-2";
export var details = "_gf-3";
export var dropdownItem = "_gf-5";
export var dropdownItemsContainer = "_gf-4";
export var fileInput = "_gf-r";
export var headerButton = "_gf-6";
export var icon = "_gf-7";
export var input = "_gf-8";
export var macroListItem = "_gf-9";
export var mainContent = "_gf-a";
export var microText = "_gf-b";
export var modal = "_gf-w";
export var optionsButton = "_gf-c";
export var paperclip = "_gf-s";
export var pillContent = "_gf-d";
export var preview = "_gf-e";
export var preview2 = "_gf-f";
export var quillEditor = "_gf-q";
export var selectedMacro = "_gf-g";
export var sidebar = "_gf-h";
export var sidebarHeader = "_gf-j";
export var sidebarList = "_gf-i";
export var sidebarListItem = "_gf-k";
export var sidebarSearch = "_gf-l";
export var snoozeDurationWrapper = "_gf-v";
export var statusPillContainer = "_gf-m";
export var tagsContainer = "_gf-n";
export var unselectedMacro = "_gf-o";
export var variable = "_gf-u";
export var wrapper = "_gf-p";